export * from '~/constants/enums/routesEnums';
export * from '~/constants/enums/uiEnums';
export * from '~/constants/enums/userEnums';

export enum Environments {
  PROD = 'production',
  DEV = 'development',
}

export enum AqarmapProSourceEnum {
  USER_MENU = 'user_menu',
  MY_ACCOUNT = 'my_account',
  SUBSCRIPTION_CHECKOUT_TOGGLE = 'subscription-checkout-toggle',
}

export enum RequestStatusEnum {
  FAILED = 'failed',
  SUCCESS = 'success',
}

export enum USER_TYPE {
  INDIVIDUAL = 0,
  BROKER = 1,
  COMPOUND_DEVELOPER = 2,
  SMALL_DEVELOPER = 3,
  ALL_TYPES = 4,
  BUYER = 5,
}
